import { AiContentCheckbox } from 'components/Composer/CustomizePostBlock/AiContentCheckbox'
import { RecycleSelector } from 'components/Posts/components/RecycleSelector'
import { ComponentType } from 'react'
import { AI_CONTENT_NETWORKS } from 'services/compose/utils'
import { BRAND_GOOGLE } from 'shared'
import { BRAND_FACEBOOK, BRAND_INSTAGRAM, BRAND_PINTEREST, BRAND_TIKTOK, BRAND_TWITTER, BRAND_YOUTUBE } from 'shared/constants'
import styles from '../BulkPost.pcss'
import { FacebookBulkOptions } from './FacebookBulkOptions'
import { GoogleBulkOptions } from './GoogleBulkOptions'
import { InstagramBulkOptions } from './InstagramBulkOptions'
import { PinterestBulkOptions } from './PinterestBulkOptions'
import { TikTokBulkOptions } from './TikTokBulkOptions'
import { TwitterBulkOptions } from './TwitterBulkOptions'
import { YouTubeBulkOptions } from './YouTubeBulkOptions'
import { BulkNetworkOptionsProps } from './types'

const NETWORK_OPTIONS: Record<string, ComponentType<BulkNetworkOptionsProps>> = {
  [BRAND_FACEBOOK]: FacebookBulkOptions,
  [BRAND_PINTEREST]: PinterestBulkOptions,
  [BRAND_INSTAGRAM]: InstagramBulkOptions,
  [BRAND_TWITTER]: TwitterBulkOptions,
  [BRAND_GOOGLE]: GoogleBulkOptions,
  [BRAND_TIKTOK]: TikTokBulkOptions,
  [BRAND_YOUTUBE]: YouTubeBulkOptions
}

export function BulkPostNetworkOptions(props: Omit<BulkNetworkOptionsProps, 'recycleSelector'>) {
  const { post } = props
  const NetworkOptions = NETWORK_OPTIONS[post.network]

  const onAiContentChange = (value: boolean) => {
    props.onAiContentChange(post.id, value)
  }

  // Unwrapped on purpose - each network decides where the selector goes and whether it needs the
  // `.option` wrapper (Google embeds it inside its own options popup).
  const recycleSelector = (
    <RecycleSelector
      value={post.recycle}
      horizontal
      onApplyToAll={props.onRecycleApplyToAll}
      onChange={props.onRecycleChange}
    />
  )

  return (
    <div className={styles['options-box']}>
      {AI_CONTENT_NETWORKS.includes(post.network) && (
        <AiContentCheckbox
          checked={Boolean(post.isAiContent)}
          id={`bulk-ai-content-${post.id}`}
          className={styles['ai-content']}
          onChange={onAiContentChange}
        />
      )}
      {NetworkOptions
        ? <NetworkOptions {...props} recycleSelector={recycleSelector} />
        : <div className={styles.option}>{recycleSelector}</div>}
      {/* One checkbox per row for every network that carries the flag - TikTok included, whose flag is per profile */}
    </div>
  )
}
